import { isLicenseVerified } from '../../common/libs/user';
import { AntaaAccountType } from '../../common/libs/antaaAccountType';
import {
  BannerSettings,
  MobileSpecialBar,
  Special,
} from '../../server/libs/siteSettings';

/**
 * `DEPARTMENT_BANNERS`オブジェクトから診療科名がマッチする最初の`Special`(特集)オブジェクトを取得する。
 */
export function findSpecialByDepartment(
  departments: { name: string }[],
  articleId?: string,
  bannerSettings?: BannerSettings,
): Special | undefined {
  for (const matchingKey of bannerSettings?.departmentBannerKeys || []) {
    if (departments.some((d) => d.name === matchingKey)) {
      const setting = bannerSettings?.departmentBanners?.[matchingKey];
      if (articleId && setting?.excludeArticleIds?.includes(articleId)) {
        continue;
      }

      return setting;
    }
  }
  return undefined;
}

/**
 * MOBILE_DEPARTMENT_BARS 配列からモバイルで下部にバナーを固定表示する設定値を取得する。
 */
export function findMobileSpecialBarByDepartment(
  departments: { name: string }[],
  articleId?: string,
  bannerSettings?: BannerSettings,
): MobileSpecialBar | undefined {
  for (const bar of bannerSettings?.mobileDepartmentBars || []) {
    if (departments.some((d) => d.name === bar.departmentName)) {
      if (articleId && bar?.excludeArticleIds?.includes(articleId)) {
        continue;
      }

      return bar;
    }
  }
  return undefined;
}
